import Button from "@mui/material/Button"
import React from "react"
import { ui } from "../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";

const nameSpace = "ErrorButton"

const showFailDialog = (reason: "Trade" | "Coverage" | "Job" | "Caravan") => {
    if (reason === "Coverage") {
        const failFeedbackReason = {
            otherPhoneId: 50,
            otherPhoneCall: "No Coverage",
            enabled: true,
            question: null
        } as unknown as typeof ui["FailFeedbackReason"];
        ui.FailFeedbackReason = failFeedbackReason
        ui.FailFeedbackDialogModal = true
        return
    }
    else if (reason === "Job") {
        const failFeedbackReason = {
            otherPhoneId: 46,
            otherPhoneCall: "Customer Realised Already Called Us",
            enabled: true,
            question: "What is the job number of their previous call ?"
        } as unknown as typeof ui["FailFeedbackReason"];
        ui.FailFeedbackReason = failFeedbackReason
        ui.FailFeedbackDialogModal = true
        return
    }
    else if (reason === "Caravan") {
        const failFeedbackReason = {
            otherPhoneId: 54,
            otherPhoneCall: "Caravan Site",
            enabled: true,
            question: null
        } as unknown as typeof ui["FailFeedbackReason"];
        ui.FailFeedbackReason = failFeedbackReason
        ui.FailFeedbackDialogModal = true
        return
    }
    ui.FailDialogModal = true
}

const ErrorButton: React.FC = () => {
    const lastJob = useAppSelector(({ state }) => state.LastJob)
    const problemCoverage = useAppSelector(({ temp }) => temp.ProblemAddressCoverage)
    const problemSearchDone = useAppSelector(({ temp }) => temp.ProblemAddressSearchDone)
    const isFirstStageFailureForbidden = useAppSelector(({ state }) => state.IsFirstStageFailureForbidden)
    const possibleCaravanSite = useAppSelector(({ state }) => state.PossibleCaravanSite)
    const propertyAddressesLength = useAppSelector(({ temp }) => temp.PropertyAddressAddressesLength)
    const isAddressSelectedOnce = useAppSelector(({ state }) => state.IsAddressSelectedOnce)
    const restrictionExpiresIn30Days = useAppSelector(({ state }) => state.RestrictionExpiresIn30Days)
    const isExpiringIn30Days = restrictionExpiresIn30Days > -1

    const reason = React.useCallback(() => {
        if (!isFirstStageFailureForbidden) {
            // order is important here so that the coverage reason is checked first and takes precedence over the trade reason and the job reason
            // if there is no coverage and the address search is done
            if (!problemCoverage && problemSearchDone) return "Coverage"
            // if there is possible caravan site
            if (possibleCaravanSite) return "Caravan"
            // if there are no addresses and the search is done
            if (propertyAddressesLength === 0 && problemSearchDone && !isAddressSelectedOnce) return "Coverage"
            // if there is no trade code selected
            if (!isAddressSelectedOnce && propertyAddressesLength === 0) return "Trade"
            // if there is a job history
            if (lastJob.length > 0) return "Job"
        }
        // already went away from the first stage
        return null
    }, [isFirstStageFailureForbidden, problemCoverage, problemSearchDone, possibleCaravanSite, propertyAddressesLength, isAddressSelectedOnce, lastJob.length])

    const error = reason()

    if (!error) {
        return null
    }

    return (<>
        {error === "Coverage" && <Button color={isExpiringIn30Days ? "warning" : "error"} variant='contained' onClick={() => showFailDialog(error)} sx={{ mt: 1, ml: 1 }}>Fail - No Coverage</Button>}
        {error === "Caravan" && <Button color='error' variant='contained' onClick={() => showFailDialog(error)} sx={{ mt: 1, ml: 1 }}>Fail - Unathorised Caravan Site</Button>}
        {error === "Trade" && <Button color='error' variant='contained' onClick={() => showFailDialog(error)} sx={{ mt: 1, ml: 1 }}>Fail Job</Button>}
        {error === "Job" && <Button color='error' variant='contained' onClick={() => showFailDialog(error)} sx={{ mt: 1, ml: 1 }}>Fail - Already Called Us</Button>}
    </>
    )
}

ErrorButton.displayName = nameSpace

export default React.memo(ErrorButton)
